export default "__VITE_ASSET__CmgN_P0P__"